
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'st-top-header-standalone-title',
  standalone: true,
  imports: [],
  templateUrl: './top-header-standalone-title.component.html',
  styleUrl: './top-header-standalone-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopHeaderStandaloneTitleComponent {
  title = input.required();
}
